import { httpClient } from '../lib/http-client';
import { LogUsuario } from '../types';

/**
 * Service para gerenciamento de logs de usuário
 */
export class LogsUsuarioService {
  static async getLogsUsuario(): Promise<LogUsuario[]> {
    return httpClient.get<LogUsuario[]>('/api/logs-usuario');
  }

  static async getLogUsuario(id: number): Promise<LogUsuario> {
    return httpClient.get<LogUsuario>(`/api/logs-usuario/${id}`);
  }

  static async createLogUsuario(data: Partial<LogUsuario>): Promise<LogUsuario> {
    return httpClient.post<LogUsuario>('/api/logs-usuario', data);
  }

  static async updateLogUsuario(id: number, data: Partial<LogUsuario>): Promise<LogUsuario> {
    return httpClient.put<LogUsuario>(`/api/logs-usuario/${id}`, data);
  }

  static async deleteLogUsuario(id: number): Promise<{ success: boolean }> {
    return httpClient.delete<{ success: boolean }>(`/api/logs-usuario/${id}`);
  }

  static async getMeusLogs(): Promise<LogUsuario[]> {
    return httpClient.get<LogUsuario[]>('/api/meus-logs');
  }

  static async getLogsPorUsuario(usuarioId: number): Promise<LogUsuario[]> {
    return httpClient.get<LogUsuario[]>(`/api/usuarios/${usuarioId}/logs`);
  }
}

